import {
  Select as ChakraSelect,
  SelectProps as ChakraSelectProps,
  FormControl,
  FormErrorMessage,
  FormLabel,
} from '@chakra-ui/react';
import React from 'react';
import { useFormContext } from 'react-hook-form';

interface ISelectProps extends Omit<ChakraSelectProps, 'name'> {
  name: string;
  label?: string;
  type?: string;
  mask?: string;
  maskChar?: string;
}

export const Select: React.FC<ISelectProps> = ({
  name,
  label,
  type,
  ...rest
}) => {
  const {
    register,
    formState: { errors },
  } = useFormContext();

  return (
    <FormControl isInvalid={!!errors[name]}>
      {label && <FormLabel htmlFor={name}>{label}</FormLabel>}
      <ChakraSelect
        id={name}
        {...register(name)}
        {...rest}
        type={type}
        bg="white"
      />
      <FormErrorMessage>
        {errors?.[name] && (errors[name]?.message as string)}
      </FormErrorMessage>
    </FormControl>
  );
};
